import React, { useState } from 'react';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import Modal from '../../../../Components/Modal/Modal';
import { Size } from '../../../../Enums/Size.enum';
// @ts-ignore
import styles from './CaseNotePreview.module.scss';

const LIMIT: number = 100;

interface Props {
	text?: string;
	className?: string;
}

const CaseNotePreview: React.FC<Props> = ({ text, className }) => {
	const [isOpen, setIsOpen] = useState(false);

	if (text && text.length < 1) {
		return <></>;
	}

	if (text && text.length > LIMIT) {
		return (
			<div>
				<span className={className}>{text.slice(0, LIMIT) + '... '}</span>
				<LinkButton
					title='base.more'
					theme={Theme.BLUE}
					className={styles.button}
					onClick={() => setIsOpen(true)}
				/>
				{isOpen && (
					<Modal
						opened={isOpen}
						onClose={() => setIsOpen(false)}
						size={Size.SM}>
						<Modal.Header title={'base.shared.note'} firstUpper />
						<Modal.Content contentScroll>
							{text && <div className={styles.note}>{text}</div>}
						</Modal.Content>
					</Modal>
				)}
			</div>
		);
	} else
		return (
			<div>
				<span className={className}>{text}</span>
			</div>
		);
};

export default CaseNotePreview;
